export default __webpack_public_path__ + "static/media/BONUS Access to 12 Self-Assessments.8ab54170.png";